{
  "login": {
    "title": "Connexion",
    "email": "E-mail professionnel",
    "password": "Mot de passe",
    "rememberMe": "Se souvenir de moi",
    "submit": "Se connecter",
    "welcomeBack": "Bon retour",
    "mfaPrompt": "Saisissez le code de votre application d'authentification",
    "mfaTitle": "Authentification à deux facteurs",
    "mfaCode": "Code d'authentification",
    "mfaVerify": "Vérifier",
    "backToLogin": "Retour à la connexion",
    "forgotPasswordLink": "Mot de passe oublié ?",
    "notMasterAdmin": "Ce compte n'est pas un administrateur maître de la plateforme",
    "platformOperatorUrl": "Les opérateurs de la plateforme doivent utiliser l'URL de connexion de la console maître.",
    "invalidCredentials": "E-mail ou mot de passe invalide",
    "invalidMfaCode": "Code d'authentification invalide",
    "googleLogin": "Se connecter avec Google",
    "newOrganization": "Nouvelle organisation ?",
    "createAccount": "Créer un compte"
  },
  "forgotPassword": {
    "title": "Mot de passe oublié",
    "email": "E-mail professionnel",
    "submit": "Envoyer le lien de réinitialisation",
    "sentTitle": "Vérifiez votre e-mail",
    "sentBody": "Si l'e-mail existe, un lien de réinitialisation a été envoyé. Vérifiez votre boîte de réception.",
    "sentToast": "Vérifiez votre e-mail pour les instructions de réinitialisation",
    "backToSignIn": "Retour à la connexion"
  },
  "resetPassword": {
    "title": "Réinitialiser le mot de passe",
    "newPassword": "Nouveau mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "submit": "Réinitialiser le mot de passe",
    "success": "Mot de passe réinitialisé — vous pouvez vous connecter",
    "invalidLink": "Lien de réinitialisation invalide",
    "failed": "Échec de la réinitialisation",
    "backToLogin": "Retour à la connexion",
    "passwordMin8": "8 caractères minimum",
    "passwordsMismatch": "Les mots de passe doivent correspondre"
  },
  "register": {
    "intro": "Créez votre compte — choisissez vos produits à l'écran suivant",
    "name": "Nom",
    "email": "E-mail",
    "phone": "Numéro de téléphone",
    "password": "Mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "continue": "Continuer",
    "googleSignUp": "S'inscrire avec Google",
    "alreadyRegistered": "Déjà inscrit ?",
    "login": "Connexion",
    "resetPassword": "Réinitialiser le mot de passe",
    "passwordMin8": "Au moins 8 caractères",
    "passwordUppercase": "Inclure une majuscule",
    "passwordLowercase": "Inclure une minuscule",
    "passwordNumber": "Inclure un chiffre",
    "passwordSpecial": "Inclure un caractère spécial",
    "nameRequired": "Nom requis",
    "emailRequired": "E-mail valide requis",
    "phoneRequired": "Numéro de téléphone requis",
    "passwordsMismatch": "Les mots de passe doivent correspondre",
    "alreadyRegisteredTitle": "Déjà inscrit",
    "wrongPasswordNotice": "Cet e-mail est déjà enregistré, mais le mot de passe est incorrect. Connectez-vous avec le bon mot de passe, réinitialisez-le ou utilisez un autre e-mail.",
    "passwordMismatchEmail": "Le mot de passe ne correspond pas à cet e-mail",
    "existingAddApp": "Votre mot de passe correspond — vous pouvez ajouter {{app}} à votre organisation existante",
    "existingLogin": "Votre mot de passe correspond — connectez-vous pour continuer avec votre organisation existante",
    "accountVerified": "Compte vérifié",
    "signedInAs": "Connecté en tant que {{email}}",
    "organization": "Organisation",
    "yourApplications": "Vos applications",
    "appAlreadyEnabled": "{{app}} est déjà sur cette organisation. Connectez-vous pour l'ouvrir — pas besoin de vous réinscrire.",
    "addAppPrompt": "Ajouter {{app}} à {{org}} ? Votre équipe garde une connexion et une organisation — facturation et utilisateurs unifiés.",
    "existingOrgPrompt": "Vous avez déjà un compte chez {{org}}. Continuez pour vous connecter — nous ne créerons pas d'organisation en double.",
    "addAppButton": "Ajouter {{app}} à {{org}}",
    "loginToOrg": "Se connecter à {{org}}",
    "loginWithoutAdding": "Se connecter sans ajouter {{app}}",
    "goToLogin": "Aller à la page de connexion",
    "useDifferentEmail": "Utiliser un autre e-mail",
    "yourOrganization": "votre organisation",
    "toastWelcome": "Bienvenue",
    "toastWelcomeModule": "Bienvenue sur {{module}}",
    "toastSignedIn": "Connecté à votre compte existant",
    "toastAppAdded": "{{app}} ajouté à {{org}}",
    "failedRegistration": "Impossible de terminer l'inscription",
    "failedAddApp": "Impossible d'ajouter l'application à votre organisation",
    "failedLogin": "Impossible de se connecter"
  },
  "toast": {
    "profilePhotoUpdated": "Photo de profil mise à jour",
    "profilePhotoRemoved": "Photo de profil supprimée",
    "passwordUpdatedYouCanContinueUsingTheApp": "Password mis à jour — you can continue using le app",
    "passwordUpdated": "Password mis à jour",
    "copied": "Copié",
    "twoFactorAuthenticationEnabled": "Authentification à deux facteurs activée",
    "twoFactorAuthenticationDisabled": "Authentification à deux facteurs désactivée",
    "openedModule": "Ouverture de {{module}}"
  },
  "errors": {
    "pleaseChooseAnImageFile": "Veuillez choisir un fichier image",
    "imageMustBeUnder2Mb": "L'image doit faire moins de 2 Mo",
    "couldNotUploadImage": "Impossible de upload image",
    "couldNotRemoveProfilePhoto": "Impossible de supprimer la photo de profil",
    "platformOperatorsMustUseTheMasterConsoleLogin": "Platform operators must utiliser le master console login URL.",
    "thisAccountIsNotAPlatformMasterAdministrator": "This account is pas a platform master administrator.",
    "platformOperatorsMustSignInFromTheMaster": "Platform operators must sign in de le master console URL.",
    "failedToChangePassword": "Échec de la modification du mot de passe",
    "enterANewPassword": "Saisissez a new password",
    "passwordActionFailed": "Échec de password action",
    "couldNotLoadMfaStatus": "Impossible de charger l'état A2F",
    "couldNotStartMfaSetup": "Impossible de démarrer la configuration A2F",
    "invalidAuthenticatorCode": "Code d'authentification invalide",
    "couldNotSaveNotificationPreferences": "Impossible d'enregistrer les préférences de notification",
    "couldNotOpenModule": "Impossible d'ouvrir {{module}}"
  },
  "moduleLogin": {
    "signedInAs": "Connecté en tant que {{email}}",
    "currentlyIn": "Vous êtes actuellement dans {{current}}.",
    "openInstead": "Ouvrir {{target}} à la place ?",
    "openModule": "Ouvrir {{module}}",
    "openingModule": "Ouverture de {{module}}…"
  },
  "pages": {
    "myProfile": "Mon profil",
    "accountDetailsAppearanceAndSecurity": "Détails du compte, apparence et sécurité",
    "twoFactorAuthentication": "Authentification à deux facteurs",
    "completingLogin": "Connexion en cours",
    "changeYourPassword": "Modifier votre mot de passe"
  },
  "profile": {
    "sections": {
      "account": "Compte",
      "preferences": "Préférences",
      "security": "Sécurité"
    },
    "signInRequired": "Connectez-vous pour voir votre profil.",
    "mfaEnabled": "A2F activée",
    "removePhoto": "Supprimer la photo",
    "uploadPhoto": "Téléverser une photo",
    "uploadingPhoto": "Téléversement…"
  },
  "labels": {
    "changeProfilePhoto": "Modifier la photo de profil",
    "profileSections": "Sections du profil",
    "email": "E-mail",
    "name": "Nom",
    "role": "Rôle",
    "authenticatorCode": "Code d'authentification",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "confirmNewPassword": "Confirmer le nouveau mot de passe"
  }
}
